'use client'

import { ShowOpenApp } from '@component/openApp'
import houseSearchPageFrom from '@pageFrom/house'
import { houseSearchType } from '@routerConfig'
import { isEstimateData, isOfflineData, isRentData, isSaleData } from '@utils/house'
import { useEffect, useState } from 'react'

export default function OpenAppBanner({
  data
}) {
  const isOffline = isOfflineData(data)
  const isBuy = isSaleData(data)
  const isRent = isRentData(data)
  const isEstimate = isEstimateData(data)
  const [isFromDisableSERP, setIsFromDisableSERP] = useState(true)

  useEffect(() => {
    const isFromNewhome = houseSearchPageFrom.isFrom(data, houseSearchType.newHomes)
    const isFromRural = houseSearchPageFrom.isFrom(data, houseSearchType.rural)

    const isFromDisableSERP = Boolean(isFromNewhome || isFromRural)
    setIsFromDisableSERP(isFromDisableSERP)
  }, [data, setIsFromDisableSERP])

  if (isFromDisableSERP || isOffline) {
    return null
  }

  return (isBuy || isRent || isEstimate) && (
    <ShowOpenApp />
  )
}